import { render, staticRenderFns } from "./supplier-type.vue?vue&type=template&id=b74b7936&"
import script from "./supplier-type.vue?vue&type=script&lang=js&"
export * from "./supplier-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports